import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

const modelUrl = process.env.REACT_APP_MODELPATH+"sofacushion1.glb";

export default function SofaCushion1Model(props) {
  const group = useRef();
  const { nodes, materials } = useGLTF(modelUrl);
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Object535.geometry}
        material={materials.Custom}
      />
    </group>
  );
}

useGLTF.preload(modelUrl);
